import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheck, Zap, Layers, Lock, Scale, UserCheck } from 'lucide-react';
export function Features() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = [{
    icon: ShieldCheck,
    title: 'Privacidad por diseño',
    description: 'Arquitectura zero-knowledge que garantiza que solo tú tienes acceso a tus datos personales.'
  }, {
    icon: Zap,
    title: 'Verificación en segundos',
    description: 'Proceso de autenticación ultrarrápido sin comprometer la seguridad ni la experiencia del usuario.'
  }, {
    icon: Layers,
    title: 'Multi-aplicación',
    description: 'Una sola identidad verificada funciona en múltiples plataformas y servicios sin repetir el proceso.'
  }, {
    icon: Lock,
    title: 'Cifrado de extremo a extremo',
    description: 'Todos tus datos están protegidos con los más altos estándares de cifrado de la industria.'
  }, {
    icon: Scale,
    title: 'Cumplimiento normativo',
    description: 'Totalmente compatible con GDPR, eIDAS, KYC/AML y otras regulaciones internacionales.'
  }, {
    icon: UserCheck,
    title: 'Control del usuario',
    description: 'Tú decides qué información compartir, cuándo y con quién. Revoca accesos en cualquier momento.'
  }];
  return <section className="py-20 md:py-32" ref={ref} data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-100">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-101">
            Características principales
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-102">
            Tecnología de vanguardia para proteger tu identidad digital
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-103">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-104">
                <div className="bg-navy-800 border border-teal-500/20 rounded-xl p-6 hover:border-teal-500/40 transition-all group h-full" data-id="element-105">
                  <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-500/20 transition-colors" data-id="element-106">
                    <Icon size={24} className="text-teal-500" data-id="element-107" />
                  </div>
                  <h3 className="text-lg font-display font-semibold text-white mb-2" data-id="element-108">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-109">
                    {feature.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}